<template>
  <div id="sidebar" class="pt-5 d-flex align-items-stretch">
    <ul class="list-group w-100">
      <li class="list-group-item" v-if="getAuthUser.role === 'admin'">
        <router-link to="/users" active-class="active">
          <img src="../../assets/img/users-icon.png" class="align-middle">
          <span class="pl-2 align-middle">Users</span>
        </router-link>
      </li>
      <li class="list-group-item" v-if="getAuthUser.role === 'admin'">
        <a href="#" @click.prevent="false">
          <img src="../../assets/img/stations-icon.png" class="align-middle">
          <span class="pl-2 align-middle">Stations</span>
        </a>
        <div class="submenu">
          <router-link :to="{name: 'Stations'}" active-class="active">
            <span class="align-middle">LNER stations</span>
          </router-link>
          <router-link :to="{name: 'StationsThirdParty'}" active-class="active">
            <span class="align-middle">Third Party Stations</span>
          </router-link>
        </div>
      </li>
      <li class="list-group-item">
        <a href="#" @click.prevent="false">
          <img src="../../assets/img/reports-icon.png" class="align-middle">
          <span class="pl-2 align-middle">Assessment History</span>
        </a>
        <div class="submenu">
          <router-link to="/reports" active-class="active">
            <span class="align-middle">LNER Assessments</span>
          </router-link>
          <router-link to="/3rdreports" active-class="active">
            <span class="align-middle">Third Party Assessments</span>
          </router-link>
        </div>
      </li>
      <li class="list-group-item" v-if="getAuthUser.role === 'admin'">
        <a href="#" @click.prevent="false">
          <img src="../../assets/img/settings-icon.png" class="align-middle">
          <span class="pl-2 align-middle">Settings</span>
        </a>
        <div class="submenu">
          <router-link to="/sections" active-class="active">
            <span class="align-middle">Sections</span>
          </router-link>
          <router-link to="/questions" active-class="active">
            <span class="align-middle">PTI Dispatch Library</span>
          </router-link>
          <router-link to="/settings" active-class="active">
            <span class="align-middle">Settings</span>
          </router-link>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    name: 'Sidebar',
    computed: {
      ...mapGetters([
        'getAuthUser',
      ]),
    }
  }
</script>

<style lang="scss">
  #sidebar {
    background: linear-gradient(180deg, #cd0e2d 0%, #740013 100%);
    width: 333px;
    min-height: 100%;
    @media (max-width: 992px) {
      width: 105px;
      .list-group-item {
        a {
          padding: 15px 30px 15px 40px !important
        }
        span {
          display: none
        }
      }
    }
    .list-group-item {
      background: none;
      border: none;
      border-radius: 0;
      padding: 0;
      a {
        font-family: 'Gotham Pro Bold', serif;
        text-transform: uppercase;
        color: #fff;
        text-decoration: none;
        display: block;
        padding: 15px 30px 15px 70px;
        &.active,
        &:hover {
          background: #850217
        }
      }
      .submenu {
        a {
          font-family: 'Gotham Pro Light', serif;
          text-transform: none;
          padding: 5px 15px 5px 102px !important;
          @media (max-width: 992px) {
            padding: 5px !important;
            font-size: 11px;
            span {
              display: block;
              text-align: center;
            }
          }
        }
      }
    }
  }
</style>
